import { getGeocode, getLatLng } from 'use-places-autocomplete';
export function isDealerLocatorEmpty(props) {
    return !props.googleApiKey || !props.mapImage;
}
function removeSymbolsInValue(value) {
    const clearedStr = value.replace(/[^\w ]/g, '');
    const resultStr = clearedStr.replace(' ', '');
    return resultStr;
}
export function getActiveItem({ searchedValue, suggestionValue, }) {
    const firstPart = removeSymbolsInValue(suggestionValue);
    const secondPart = removeSymbolsInValue(searchedValue);
    return firstPart === secondPart;
}
export function getClearedDealerList(data = []) {
    return data.reduce((acc = [], item) => {
        if (!acc) {
            return [item];
        }
        const isValueAlreadyExist = acc.some((j) => getActiveItem({
            suggestionValue: j?.description || '',
            searchedValue: item.description || '',
        }));
        if (isValueAlreadyExist) {
            return [...acc];
        }
        return [...acc, item];
    }, []);
}
export const getLocationFromSearchedPlace = async (place) => {
    const { latitude, longitude, value } = place;
    if (latitude && longitude) {
        return {
            coordinates: {
                lat: latitude,
                lng: longitude,
            },
            label: value || '',
        };
    }
    else {
        const results = await getGeocode({
            address: value,
        });
        const { lat, lng } = getLatLng(results[0]);
        const coordinates = {
            lat,
            lng,
        };
        return {
            coordinates,
            label: value,
        };
    }
};
